import { render } from "./BrandingInfo.vue?vue&type=template&id=58173e28&scoped=true"
import script from "./BrandingInfo.vue?vue&type=script&lang=js"
export * from "./BrandingInfo.vue?vue&type=script&lang=js"

import "./BrandingInfo.vue?vue&type=style&index=0&id=58173e28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58173e28"]])

export default __exports__